import styled from 'styled-components';

const UpdateClientWrapper = styled.div`
  .header-user-wrapper {
    .user-name, .user-username, .user-actions {
      width: 20%;
      margin: 0;
      font-size: 18px;
      color: #000;
    }
    .user-email {
      width: 40%;
      margin: 0;
      font-size: 18px;
      color: #000;
    }
  }
  .user-wrapper {
    width: 100%;
    align-items: center;
    .user-update-icon {
      opacity: 0;
      margin-top: 3px;
      pointer-events: none;
      color: #2979ff;
      font-size: 20px;
      margin-left: 20px;
      transition: all 0.2s ease-out;
    }
    .user-name, .user-username, .user-actions {
      width: 20%;
      margin: 0;
      word-wrap: break-word;
    }
    .user-email {
      width: 40%;
      margin: 0;
      word-wrap: break-word;
    }
  }
  .ant-list-item {
    transition: all 0.2s ease-out;
    &:hover {
      color: #2979ff;
      background-color: #f0f8ff;
      .user-update-icon {
        opacity: 1;
        pointer-events: all;
        cursor: pointer;
      }
    }
  }
  .search-client-input {
    border: none;
    border-bottom: 1px solid #333;
    outline: none;
    width: 100%;
    margin: 10px 0 20px 0;
  }
`;

export default UpdateClientWrapper;


// WEBPACK FOOTER //
// ./src/components/Client/UpdateClient/UpdateClient.style.js